const termsTranslations = {
  pt: {
  title: "Termos de Uso – Kito",
  sections: [
    {
      heading: "1. Identificação da Detentora",
      content: [
        "Este ecossistema digital é operado pela KITO EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA, inscrita sob o CNPJ 57.276.139/0001-80, com sede na Rua Padre Estêvão Pernet, 160, CJ 1007, Tatuapé, São Paulo - SP, CEP 03315-000. Ao utilizar a plataforma, o usuário aceita integralmente estes Termos."
      ]
    },
    {
      heading: "2. Objeto Social e Atividades",
      content: [
        "A Kito atua como editora de livros, provedora de conteúdo interativo, licenciadora de programas de computador (software) e desenvolvedora de soluções em tecnologia da informação, integrando educação e entretenimento digital."
      ]
    },
    {
      heading: "3. Elegibilidade e Consentimento",
      content: [
        "O uso por menores de 18 anos deve ser assistido ou autorizado pelos pais ou responsáveis legais. O cadastro de menores de 16 anos deve ser realizado obrigatoriamente pelo tutor legal, em estrita observância à LGPD (Lei Geral de Proteção de Dados) e ao ECA (Estatuto da Criança e do Adolescente)."
      ]
    },
    {
      heading: "4. Propriedade Intelectual do Software",
      content: [
        "O licenciamento de nossos programas de computador é não customizável e de uso pessoal. Todos os algoritmos, códigos-fonte e interfaces do Kito App e Kito Games pertencem exclusivamente à Kito Editora."
      ]
    },
    {
      heading: "5. Proteção da Turma do Kito (Personagens)",
      content: [
        "Os personagens **Kito, Fuzzy, Paninho, Berta, Pituca e Florzinha** são ativos intelectuais protegidos por direitos autorais e de marca. É proibida qualquer reprodução ou criação de obras derivadas sem autorização prévia por escrito."
      ]
    },
    {
      heading: "6. Atividade de Edição de Livros e 'Modelo de Posse'",
      content: [
        "No exercício de sua atividade de edição de livros, a Kito disponibiliza títulos no 'modelo de posse'. O usuário adquire a propriedade definitiva de arquivos digitais (e-books/MiniBooks), garantindo o direito de propriedade perpétuo sobre o exemplar adquirido, conforme a Lei do Livro (Lei 10.753/2003)."
      ]
    },
    {
      heading: "7. Imunidade Tributária e Parcerias ISP",
      content: [
        "O fornecimento de livros digitais em caráter definitivo (posse) é amparado pela imunidade tributária constitucional. Em parcerias com Provedores de Internet (ISPs), o faturamento desses itens poderá ser destacado conforme a legislação vigente para serviços de valor adicionado e produtos editoriais."
      ]
    },
    {
      heading: "8. Kito Games e Conteúdo Gamificado",
      content: [
        "O ambiente Kito Games oferece programas de computador para fins educativos e recreativos. O acesso a esses jogos é vinculado à manutenção da assinatura ou condições específicas de planos promocionais."
      ]
    },
    {
      heading: "9. Uso de Inteligência Artificial Literária",
      content: [
        "A Kito utiliza tecnologias de IA para personalização de narrativas. O usuário compreende que o conteúdo gerado é experimental e dinâmico. Implementamos filtros de segurança ativa para garantir a adequação ao público infantil."
      ]
    },
    {
      heading: "10. Propriedade sobre Narrativas Geradas",
      content: [
        "Todas as variações de histórias e textos criados pela IA dentro da plataforma, mesmo que baseados em escolhas do usuário, são de propriedade intelectual da Kito Editora, sendo licenciadas apenas para fruição pessoal do usuário."
      ]
    },
    {
      heading: "11. Vouchers e Códigos de Parceiros",
      content: [
        "O uso de vouchers distribuídos por parceiros comerciais está sujeito à validade estipulada no momento da emissão e vincula-se às regras de ativação presentes na interface do usuário."
      ]
    },
    {
      heading: "12. Restrições de Uso e Segurança",
      content: [
        "É terminantemente proibido: (i) realizar engenharia reversa; (ii) utilizar robôs ou scraping para extração de dados; (iii) burlar sistemas de segurança ou autenticação da Kito Editora."
      ]
    },
    {
      heading: "13. Obras de Terceiros e Domínio Público",
      content: [
        "Livros de domínio público são integrados à plataforma respeitando os direitos morais dos autores. A diagramação e os recursos interativos adicionados a essas obras pela Kito Editora são protegidos por direitos autorais."
      ]
    },
    {
      heading: "14. Privacidade e Tratamento de Dados",
      content: [
        "A coleta de dados visa a melhoria da experiência de leitura e segurança. Adotamos padrões rigorosos de proteção de dados, especialmente no tratamento de informações de menores de idade."
      ]
    },
    {
      heading: "15. Modelo Freemium e Assinaturas",
      content: [
        "Assinaturas Premium são processadas via Google Play e App Store. O gerenciamento de renovação automática e cancelamento deve ser feito pelo usuário através das ferramentas da respectiva loja."
      ]
    },
    {
      heading: "16. Isenção de Garantias Técnicas",
      content: [
        "A Kito Editora não garante que os serviços serão totalmente livres de interrupções ou erros, fornecendo o software no estado em que se encontra ('as is')."
      ]
    },
    {
      heading: "17. Limitação de Responsabilidade Civil",
      content: [
        "A empresa não se responsabiliza por danos decorrentes de falhas de hardware do usuário, instabilidade de provedores de internet externos ou uso inadequado das ferramentas de IA."
      ]
    },
    {
      heading: "18. Modificações e Notificações",
      content: [
        "Podemos atualizar estes Termos para refletir mudanças em nosso objeto social ou requisitos legais. O uso continuado após a notificação implica na aceitação das novas regras."
      ]
    },
    {
      heading: "19. Foro de Eleição",
      content: [
        "Estes Termos são regidos pelas leis brasileiras. Fica eleito o foro da Comarca de São Paulo/SP para dirimir quaisquer controvérsias oriundas deste contrato."
      ]
    },
    {
      heading: "20. Contato e Atendimento",
      content: [
        "Para solicitações administrativas ou suporte, utilize o e-mail: <a href='mailto:contato@kito.app.br'>contato@kito.app.br</a>."
      ]
    }
  ]
},

  
  en: {
  title: "Terms of Use – Kito",
  sections: [
    {
      heading: "1. Identification of the Provider",
      content: [
        "This digital ecosystem is operated by **KITO EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA**, headquartered at Rua Padre Estêvão Pernet, 160, CJ 1007, Tatuapé, São Paulo - SP, CEP 03315-000, Brazil. By using this platform, the user (or their legal guardian) fully accepts these Terms."
      ]
    },
    {
      heading: "2. Corporate Purpose and Activities",
      content: [
        "Kito operates as a book publisher, interactive content provider, computer program (software) licensor, and information technology solutions developer, integrating digital education and entertainment."
      ]
    },
    {
      heading: "3. Eligibility and Consent",
      content: [
        "Use by individuals under 18 must be assisted or authorized by parents or legal guardians. Registration for those under 16 must be performed exclusively by a legal guardian, in strict compliance with applicable data protection and child protection laws."
      ]
    },
    {
      heading: "4. Intellectual Property of the Software",
      content: [
        "The licensing of our computer programs is non-customizable and for personal use only. All algorithms, source codes, and interfaces of the Kito App and Kito Games belong exclusively to Kito Editora."
      ]
    },
    {
      heading: "5. Protection of 'Kito & Friends' (Characters)",
      content: [
        "The characters **Kito (cockatiel), Fuzzy (bear), Paninho, Berta (fish), Pituca, and Florzinha (shih-tzus)** are protected intellectual assets under copyright and trademark laws. Any reproduction or creation of derivative works without prior written authorization is strictly prohibited."
      ]
    },
    {
      heading: "6. Book Publishing Activity and 'Ownership Model'",
      content: [
        "Within its book publishing activities, Kito provides titles under an 'ownership model'. The user acquires definitive ownership of digital files (e-books/MiniBooks), ensuring perpetual property rights over the acquired copy, in accordance with applicable legislation."
      ]
    },
    {
      heading: "7. Tax Immunity and ISP Partnerships",
      content: [
        "The provision of digital books on a definitive basis (ownership) is supported by constitutional tax immunity for books. In partnerships with Internet Service Providers (ISPs), billing for these items may be segregated in accordance with current legislation for value-added services and editorial products."
      ]
    },
    {
      heading: "8. Kito Games and Gamified Content",
      content: [
        "The Kito Games environment offers computer programs for educational and recreational purposes. Access to these games is tied to maintaining a subscription or specific promotional plan conditions."
      ]
    },
    {
      heading: "9. Use of Literary Artificial Intelligence",
      content: [
        "Kito utilizes AI technologies for narrative personalization. The user understands that the generated content is experimental and dynamic. We implement active safety filters to ensure suitability for children."
      ]
    },
    {
      heading: "10. Ownership of Generated Narratives",
      content: [
        "All variations of stories and texts created by AI within the platform, even if based on user choices, are the intellectual property of Kito Editora and are licensed only for the user's personal enjoyment."
      ]
    },
    {
      heading: "11. Vouchers and Partner Codes",
      content: [
        "The use of vouchers distributed by commercial partners is subject to the validity period stipulated at the time of issuance and is bound by the activation rules present in the user interface."
      ]
    },
    {
      heading: "12. Usage Restrictions and Security",
      content: [
        "It is strictly prohibited to: (i) perform reverse engineering; (ii) use robots or scraping for data extraction; (iii) bypass security or authentication systems of Kito Editora."
      ]
    },
    {
      heading: "13. Third-Party Works and Public Domain",
      content: [
        "Public domain books are integrated into the platform respecting the moral rights of the authors. The layout and interactive features added to these works by Kito Editora are protected by copyright."
      ]
    },
    {
      heading: "14. Privacy and Data Processing",
      content: [
        "Data collection aims to improve the reading experience and security. We adopt rigorous data protection standards, especially regarding the information of minors."
      ]
    },
    {
      heading: "15. Freemium Model and Subscriptions",
      content: [
        "Premium subscriptions are processed via Google Play and the App Store. Auto-renewal management and cancellations must be handled by the user through the respective store's tools."
      ]
    },
    {
      heading: "16. Disclaimer of Technical Warranties",
      content: [
        "Kito Editora does not guarantee that services will be entirely free from interruptions or errors, providing the software 'as is'."
      ]
    },
    {
      heading: "17. Limitation of Civil Liability",
      content: [
        "The company is not responsible for damages resulting from user hardware failures, external internet provider instability, or the inappropriate use of AI tools."
      ]
    },
    {
      heading: "18. Modifications and Notifications",
      content: [
        "We may update these Terms to reflect changes in our corporate purpose or legal requirements. Continued use following notification implies acceptance of the new rules."
      ]
    },
    {
      heading: "19. Governing Law and Jurisdiction",
      content: [
        "These Terms are governed by Brazilian law. The courts of São Paulo/SP are elected to resolve any controversies arising from this agreement."
      ]
    },
    {
      heading: "20. Contact and Support",
      content: [
        "For administrative requests or support, please use the email: <a href='mailto:contato@kito.app.br'>contato@kito.app.br</a>."
      ]
    }
  ]
},


  es: {
  title: "Términos de Uso – Kito",
  sections: [
    {
      heading: "1. Identificación de la Titular",
      content: [
        "Este ecosistema digital es operado por **KITO EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA**, con sede en Rua Padre Estêvão Pernet, 160, CJ 1007, Tatuapé, São Paulo - SP, CEP 03315-000, Brasil. Al utilizar la plataforma, el usuario acepta íntegramente estos Términos."
      ]
    },
    {
      heading: "2. Objeto Social y Actividades",
      content: [
        "Kito actúa como editora de libros, proveedora de contenido interactivo, licenciadora de programas de computadora (software) y desarrolladora de soluciones en tecnología de la información, integrando educación y entretenimiento digital."
      ]
    },
    {
      heading: "3. Elegibilidad y Consentimiento",
      content: [
        "El uso por menores de 18 años debe ser asistido o autorizado por los padres o responsables legales. El registro de menores de 16 años debe ser realizado obligatoriamente por el tutor legal, en estricta observancia de las leyes de protección de datos y del menor."
      ]
    },
    {
      heading: "4. Propiedad Intelectual del Software",
      content: [
        "El licenciamiento de nuestros programas de computadora es no personalizable y para uso personal. Todos los algoritmos, códigos fuente e interfaces de Kito App y Kito Games pertenecen exclusivamente a Kito Editora."
      ]
    },
    {
      heading: "5. Protección de la 'Turma do Kito' (Personajes)",
      content: [
        "Los personajes **Kito, Fuzzy, Paninho, Berta, Pituca y Florzinha** son activos intelectuales protegidos por derechos de autor y de marca. Se prohíbe cualquier reproducción o creación de obras derivadas sin autorización previa por escrito."
      ]
    },
    {
      heading: "6. Actividad de Edición de Libros y 'Modelo de Posesión'",
      content: [
        "En el ejercicio de su actividad editorial, Kito ofrece títulos bajo el 'modelo de posesión'. El usuario adquiere la propiedad definitiva de archivos digitales (e-books/MiniBooks), garantizando el derecho de propiedad perpetuo sobre el ejemplar adquirido."
      ]
    },
    {
      heading: "7. Inmunidad Tributaria y Alianzas con ISPs",
      content: [
        "El suministro de libros digitales con carácter definitivo (posesión) está amparado por la inmunidad tributaria constitucional para libros. En alianzas con Proveedores de Internet (ISPs), la facturación de estos artículos podrá desglosarse según la legislación vigente para servicios de valor añadido y productos editoriales."
      ]
    },
    {
      heading: "8. Kito Games y Contenido Gamificado",
      content: [
        "El entorno Kito Games ofrece programas de computadora con fines educativos y recreativos. El acceso a estos juegos está vinculado al mantenimiento de la suscripción o a condiciones específicas de planes promocionales."
      ]
    },
    {
      heading: "9. Uso de Inteligencia Artificial Literaria",
      content: [
        "Kito utiliza tecnologías de IA para la personalización de narrativas. El usuario comprende que el contenido generado es experimental y dinámico. Implementamos filtros de seguridad activa para garantizar la adecuación al público infantil."
      ]
    },
    {
      heading: "10. Propiedad sobre Narrativas Generadas",
      content: [
        "Todas las variaciones de historias y textos creados por la IA dentro de la plataforma, incluso si se basan en elecciones del usuario, son propiedad intelectual de Kito Editora, licenciándose únicamente para el disfrute personal del usuario."
      ]
    },
    {
      heading: "11. Vales y Códigos de Socios",
      content: [
        "El uso de vales (vouchers) distribuidos por socios comerciales está sujeto a la validez estipulada en el momento de la emisión y se vincula a las reglas de activación presentes en la interfaz de usuario."
      ]
    },
    {
      heading: "12. Restricciones de Uso y Seguridad",
      content: [
        "Está terminantemente prohibido: (i) realizar ingeniería inversa; (ii) utilizar robots o scraping para la extracción de datos; (iii) eludir los sistemas de seguridad o autenticación de Kito Editora."
      ]
    },
    {
      heading: "13. Obras de Terceros y Dominio Público",
      content: [
        "Los libros de dominio público se integran en la plataforma respetando los derechos morales de los autores. El diseño y los recursos interactivos añadidos a estas obras por Kito Editora están protegidos por derechos de autor."
      ]
    },
    {
      heading: "14. Privacidad y Tratamiento de Datos",
      content: [
        "La recopilación de datos busca mejorar la experiencia de lectura y la seguridad. Adoptamos estándares rigurosos de protección de datos, especialmente en el tratamiento de información de menores de edad."
      ]
    },
    {
      heading: "15. Modelo Freemium y Suscripciones",
      content: [
        "Las suscripciones Premium se procesan a través de Google Play y App Store. La gestión de la renovación automática y la cancelación debe ser realizada por el usuario a través de las herramientas de la tienda respectiva."
      ]
    },
    {
      heading: "16. Exención de Garantías Técnicas",
      content: [
        "Kito Editora no garantiza que los servicios estén totalmente libres de interrupciones o errores, proporcionando el software en el estado en que se encuentra ('as is')."
      ]
    },
    {
      heading: "17. Limitación de Responsabilidad Civil",
      content: [
        "La empresa no se responsabiliza por daños derivados de fallos en el hardware del usuario, inestabilidad de proveedores de internet externos o el uso inadecuado de las herramientas de IA."
      ]
    },
    {
      heading: "18. Modificaciones y Notificaciones",
      content: [
        "Podemos actualizar estos Términos para reflejar cambios en nuestro objeto social o requisitos legales. El uso continuado tras la notificación implica la aceptación de las nuevas reglas."
      ]
    },
    {
      heading: "19. Fuero y Legislación Aplicable",
      content: [
        "Estos Términos se rigen por las leyes brasileñas. Se elige el foro de la Ciudad de São Paulo/SP para resolver cualquier controversia derivada de este contrato."
      ]
    },
    {
      heading: "20. Contacto y Soporte",
      content: [
        "Para solicitudes administrativas o soporte, utilice el correo electrónico: <a href='mailto:contato@kito.app.br'>contato@kito.app.br</a>."
      ]
    }
  ]
},

};

export default termsTranslations;
